module.exports = __webpack_public_path__ + "static/media/chevron-down-ic.67e6cb5a.svg";